import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { SaasProvider } from "@saas-ui/react";
import posthog from "posthog-js";
import { PostHogProvider } from "posthog-js/react";

posthog.init(process.env.REACT_APP_POSTHOG_API_KEY, {
  api_host: "https://us.i.posthog.com",
  autocapture: true,
  capture_pageview: true,
  capture_pageleave: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <SaasProvider>
      <PostHogProvider client={posthog}>
        <App />
      </PostHogProvider>
    </SaasProvider>
  </React.StrictMode>
);
